module.exports = __webpack_public_path__ + "img/User-Icon.496fd6d1.svg";